var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"next action-button",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" পূর্বের ধাপ ")])])}
var staticRenderFns = []

export { render, staticRenderFns }